document.addEventListener("DOMContentLoaded", () => {
	const loadMoreBtn = document.querySelector('.js-load_more_solutions');
	const hiddenClass = 'm-hidden';

	if (!loadMoreBtn) {
		return;
	}

	loadMoreBtn.addEventListener('click', () => {
		const parent = loadMoreBtn.parentElement;

		if (parent) {
			const hiddenServices = parent.querySelectorAll('.m-hidden');

			let timeout = 0;

			hiddenServices.forEach(serviceTile => {
				setTimeout(() => {
					serviceTile.classList.remove(hiddenClass);
					serviceTile.style.opacity = 1;
				}, timeout);

				timeout += 400;
			});

			setTimeout(() => {
				loadMoreBtn.remove();
			}, hiddenServices.length * 400);
		}
	})
});
